﻿import { token } from "../../token";

export class booking_search_request {
    public token: token = new token();
}